import { useTranslation } from 'react-i18next';
import * as Styled from './OtherAmount.styled';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const OtherAmount = _ref => {
  let {
    dataId,
    currencyCode,
    currencySymbol,
    error,
    isActive,
    doFadeIn,
    otherAmountDisplayValue,
    formHasPresets,
    handleOtherInputBlur,
    handleOtherInputChange
  } = _ref;
  const {
    t
  } = useTranslation('blocks.donation');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Styled.CurrencyPicker, {
      "data-id": "cp-donation-form-currency",
      doFadeIn: doFadeIn,
      isActive: isActive,
      error: !!error,
      children: [/*#__PURE__*/_jsx("span", {
        children: currencyCode
      }), /*#__PURE__*/_jsxs("span", {
        children: [currencySymbol, /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx("input", {
            "data-id": dataId,
            id: "other-donation-amount",
            "aria-label": t('OtherAmount.customDonationAmountAriaLabel', 'Custom donation amount'),
            "aria-invalid": !!error,
            placeholder: formHasPresets ? t('OtherAmount.placeholderOther', 'Other') : t('OtherAmount.placeholderAmount', 'Amount'),
            onChange: e => {
              handleOtherInputChange(e);
            },
            onBlur: handleOtherInputBlur,
            value: otherAmountDisplayValue
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Styled.ErrorLabel, {
      "aria-live": "assertive",
      "aria-relevant": "additions",
      children: error && `\u26A0 ${error}`
    })]
  });
};